/**
 * Hook that derives the taskTemplateSetId for an existing project.
 *
 * The mini-initialisation flow needs to load the same template data the
 * project was originally created with (template PPs, work sections, tasks).
 * The backend computes this via Project → Plot → ProcurementPackage →
 * TemplateProcurementPackage.taskTemplateSetId — we just query and forward.
 */

import { gql, useQuery } from "@apollo/client";

const GET_PROJECT_TASK_TEMPLATE_SET_ID = gql`
  query GetProjectTaskTemplateSetId($projectId: String!) {
    projectTaskTemplateSetId(projectId: $projectId)
  }
`;

export function useProjectTaskTemplateSetId(
  projectId: string | null | undefined,
) {
  const { data, loading, error } = useQuery<{
    projectTaskTemplateSetId: string | null;
  }>(GET_PROJECT_TASK_TEMPLATE_SET_ID, {
    variables: { projectId: projectId ?? "" },
    skip: !projectId,
    fetchPolicy: "cache-and-network",
  });

  return {
    taskTemplateSetId: data?.projectTaskTemplateSetId ?? null,
    loading,
    error: error ?? null,
  };
}
